<script setup lang="ts">
import { computed } from 'vue'
import DOMPurify from 'dompurify'
import MarkdownIt from 'markdown-it'
import anchor from 'markdown-it-anchor'
import taskLists from 'markdown-it-task-lists'
const props = defineProps<{ markdown: string; sourcePath?: string }>()
const renderer = new MarkdownIt({ html: false, linkify: true, typographer: true }).use(anchor).use(taskLists, { enabled: true, label: true })
function documentationHref(href: string, sourcePath?: string) {
  const [target, fragment] = href.split('#', 2)
  if (!target.endsWith('.md')) return href
  const segments = target.startsWith('/') ? [] : (sourcePath || '').split('/').slice(0, -1)
  for (const segment of target.replace(/^\/+/, '').replace(/\.md$/, '').split('/')) {
    if (!segment || segment === '.') continue
    if (segment === '..') segments.pop()
    else segments.push(segment)
  }
  return `/docs/${segments.join('/')}${fragment ? `#${fragment}` : ''}`
}
renderer.renderer.rules.link_open = (tokens, index, options, env, self) => { const href = tokens[index].attrGet('href') || ''; if (/^https?:\/\//.test(href)) { tokens[index].attrSet('target', '_blank'); tokens[index].attrSet('rel', 'noopener noreferrer') } else tokens[index].attrSet('href', documentationHref(href, (env as { sourcePath?: string }).sourcePath)); return self.renderToken(tokens, index, options) }
const html = computed(() => DOMPurify.sanitize(renderer.render(props.markdown, { sourcePath:props.sourcePath }), { USE_PROFILES: { html: true } }))
</script><template><article class="markdown" v-html="html"/></template>
